import { render, staticRenderFns } from "./CreateKeywordsModal.vue?vue&type=template&id=332bb4e9&scoped=true&"
import script from "./CreateKeywordsModal.vue?vue&type=script&lang=js&"
export * from "./CreateKeywordsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateKeywordsModal.vue?vue&type=style&index=0&id=332bb4e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bb4e9",
  null
  
)

export default component.exports